import { Space } from "antd";
import dayjs from "dayjs";
import CalendarButton from "../CalendarButton";
import DateDisplay, { DateDisplaySimple } from "../DateDisplay";

const SessionDateDisplay = ({ session }) => {
  let now = dayjs();
  let sessionStart = dayjs(session?.StartTime);
  let sessionEnd = dayjs(session?.EndTime);

  let day, start, end;

  if (now.startOf("day") === sessionStart.startOf("day")) day = "Today";
  else day = sessionStart.format("ddd MMM Do");

  start = sessionStart.format("h:mma");
  end = sessionEnd.format("h:mma");

  return (
    <Space direction="vertical">
      <DateDisplay date={day} time={start} end={end} />
      {/* <CalendarButton
        title={"Hi"}
        description="hi"
        start={sessionStart}
        end={sessionEnd}
        size="small"
        type="text"
        display={"Add"}
      /> */}
    </Space>
  );
};

export default SessionDateDisplay;
